// extracted by mini-css-extract-plugin
export default {"countdownTimer":"styles_countdownTimer__bV7j5"};